import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 22, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export const SectionTitle = ({ eyebrow, title, sub }) => (
  <div className="max-w-2xl">
    {eyebrow && <div className="inline-flex items-center px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider bg-[#EEF0FF] text-[#4A3BFA] mb-4">{eyebrow}</div>}
    <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h2>
    {sub && <p className="mt-3 text-slate-500 text-base md:text-lg">{sub}</p>}
  </div>
);
